// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * core-service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1-35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    PageV1APIModel,
    PageV1APIModelFromJSON,
    PageV1APIModelFromJSONTyped,
    PageV1APIModelToJSON,
} from './';

/**
 * 
 * @export
 * @interface TransactionFilterAPIModel
 */
export interface TransactionFilterAPIModel {
    /**
     * 
     * @type {Date}
     * @memberof TransactionFilterAPIModel
     */
    dateFrom?: Date;
    /**
     * 
     * @type {Date}
     * @memberof TransactionFilterAPIModel
     */
    dateTo?: Date;
    /**
     * 
     * @type {PageV1APIModel}
     * @memberof TransactionFilterAPIModel
     */
    page?: PageV1APIModel;
}

export function TransactionFilterAPIModelFromJSON(json: any): TransactionFilterAPIModel {
    return TransactionFilterAPIModelFromJSONTyped(json, false);
}

export function TransactionFilterAPIModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): TransactionFilterAPIModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'dateFrom': !exists(json, 'dateFrom') ? undefined : (new Date(json['dateFrom'])),
        'dateTo': !exists(json, 'dateTo') ? undefined : (new Date(json['dateTo'])),
        'page': !exists(json, 'page') ? undefined : PageV1APIModelFromJSON(json['page']),
    };
}

export function TransactionFilterAPIModelToJSON(value?: TransactionFilterAPIModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'dateFrom': value.dateFrom === undefined ? undefined : (value.dateFrom.toISOString()),
        'dateTo': value.dateTo === undefined ? undefined : (value.dateTo.toISOString()),
        'page': PageV1APIModelToJSON(value.page),
    };
}


